module.exports = __webpack_public_path__ + "static/media/Search.b057da5b.svg";